import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['email'];

  toggle(event) {
    const required = event.target.value === 'applicant';
    const inputController = this.application.getControllerForElementAndIdentifier(
      this.emailTarget.closest('[data-controller~="input"]'),
      'input',
    );
    if (!inputController) return;

    inputController.setRequired(required);
    if (required) return;

    inputController.clearValidationError();
    if (inputController.hasHelperTarget) inputController.helperTarget.style.display = 'none';
  }
}
